import React from 'react';
import classNames from 'classnames';
import CodeSparkThemedTypography from '../../../../../components/elements/CodeSparkThemedTypography';
import { useExperimentContext } from '../../../../../experiments/context';

import styles from './PlanSelectorV3.module.css';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/global`;

export default function SubscriptionPlan({
  planId,
  title,
  comparisonPlanPriceDisplay,
  priceDisplay,
  billingLegal,
  showGlitch,
  percentChange,
  selected,
  onClick,
  eyebrowHeader,
  trial,
}) {
  const {
    experiments: { differentPlanTrials },
  } = useExperimentContext();

  return (
    <div key={planId} className={styles.subscriptionPlanContainer}>
      {showGlitch && (
        <div className={styles.glitchWrapper}>
          <img src={`${imgURL}/peeking-foos.svg`} alt="" />
        </div>
      )}

      {percentChange && (
        <div className={styles.flagWrapper}>
          <CodeSparkThemedTypography variant="body1" className={styles.flagText}>
            SAVE {percentChange}
          </CodeSparkThemedTypography>
        </div>
      )}

      <div
        className={classNames(styles.subscriptionPlanCard, {
          [styles.selected]: selected,
        })}
        onClick={onClick}
      >
        <CodeSparkThemedTypography
          variant="body3"
          className={styles.subscriptionPlanCardEyebrowHeader}
        >
          {eyebrowHeader}
        </CodeSparkThemedTypography>

        <CodeSparkThemedTypography variant="h4" className={styles.subscriptionPlanCardTitle}>
          {title}
        </CodeSparkThemedTypography>

        <div className={styles.subscriptionPlanCardPricesContainer}>
          {comparisonPlanPriceDisplay && (
            <CodeSparkThemedTypography
              variant="body1"
              className={styles.subscriptionPlanCardOriginalPrice}
            >
              <s>{comparisonPlanPriceDisplay}</s>
            </CodeSparkThemedTypography>
          )}
          <CodeSparkThemedTypography variant="body1" className={styles.subscriptionPlanCardPrice}>
            {priceDisplay}
          </CodeSparkThemedTypography>
        </div>

        {differentPlanTrials && (
          <CodeSparkThemedTypography variant="body2" className={styles.subscriptionPlanCardTrial}>
            {trial}
          </CodeSparkThemedTypography>
        )}

        <CodeSparkThemedTypography
          variant="body3"
          className={styles.subscriptionPlanCardBillingLegal}
        >
          <i>{billingLegal}</i>
        </CodeSparkThemedTypography>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/V3/SubscriptionPlan.js